/**
 * Il logo della CER per l'intestazione del PDF (INB-380): scaricato dall'URL
 * pubblico del bucket `branding` e reso data URL, con le dimensioni naturali
 * perché jsPDF lo disegni in proporzione. Qualunque errore → `null`: il PDF
 * ripiega su «SLIMS», come prima.
 */
export async function loadReportLogo(
	url: string | null | undefined,
): Promise<{ dataUrl: string; width: number; height: number } | null> {
	if (!url) return null;
	try {
		const res = await fetch(url);
		if (!res.ok) return null;
		const blob = await res.blob();
		if (!/^image\/(png|jpe?g)$/.test(blob.type)) return null;
		const dataUrl = await new Promise<string>((resolve, reject) => {
			const reader = new FileReader();
			reader.onload = () => resolve(String(reader.result));
			reader.onerror = () => reject(reader.error);
			reader.readAsDataURL(blob);
		});
		const { width, height } = await new Promise<{ width: number; height: number }>(
			(resolve, reject) => {
				const img = new Image();
				img.onload = () => resolve({ width: img.naturalWidth, height: img.naturalHeight });
				img.onerror = reject;
				img.src = dataUrl;
			},
		);
		return width > 0 && height > 0 ? { dataUrl, width, height } : null;
	} catch {
		return null;
	}
}
